
import './App.css';
import Header from './components/Header';
import CardContainer from './components/CardContainer';
import Container from 'react-bootstrap/esm/Container';

function App() {
  return (
    <Container className='text-center mt-4'>
     <Header/>
     <CardContainer/>
    </Container>
  );
}

export default App;
